module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue.0e962645.jpg";